import React from "react";
import "../App.css";
import { Route, Routes , Router} from "react-router-dom";
import ContentCategory from "./ContentCategory";
import Tag from "../Components/Tag";
import NotFound from "../Components/NotFound";
import Lazy from "../Components/Lazy";
import Scrolltop from "../Components/Scrolltop";
import Homepage from "./Homepage";

import About from "./About";

import Connect from "./Connect";
import Author from "./Author";
import Privacy from "./Privacy";
import DoNotSell from "./DoNotSell";
import Topic from "./Topic";
import Searchlist from "./Searchlist";
import Unsubscribe from "./Unsubscribe";
import PostPreview from "./PostPreview";
import Sitemap from "./Sitemap";
// import SitemapPost from "./Sitemappost";
import NewTopicCode from "./NewTopicCode"
import TopicSecondPage from "./TopicSecondPage"
import Events from "./Events";
import Eventpage from "./Event";
import EventDetail from "./EventDetail";
import Accordian from "../ReusableComp/Accordian";
import SubLandingPage from "./SubLandingPage";


const MainRoutes = () => {
  return (
    <>
    <Routes>
      <Route path="/" element={<Homepage />}></Route>

      {/* Krishna */}
      <Route path="/accordian" element={<Accordian />}></Route>
      <Route path="/sublanding" element={<SubLandingPage />}></Route>
      {/* Krishna */}
      
      <Route path="/About" element={<About />}></Route>
      <Route path="/ContentCategory" element={<ContentCategory />}></Route>
      <Route path="/contact-us" element={<Connect />}></Route>
      <Route path="/event" element={<Eventpage/>}></Route>
      <Route path="/events/:event_slug" element={<EventDetail />} />
      <Route path="/Author" element={<Author />}></Route>
      <Route path="/Unsubscribe" element={<Unsubscribe />}></Route>
      <Route path="/Tag" element={<Tag />}></Route>
      <Route path="/privacy-policy" element={<Privacy />}></Route>
      <Route path="/opt-out-form" element={<DoNotSell />}></Route>
      <Route path="/sitemap" element={<Sitemap />}></Route>
      {/* <Route path="/sitemapost" element={<SitemapPost />}></Route> */}
      <Route path="/NotFound" element={<NotFound />}></Route>
      <Route path="/Lazy" element={<Lazy />}></Route>
      <Route path="/Scrolltop" element={<Scrolltop />}></Route>
      <Route exact path="/tag/:subcat" element={<Tag />} />
      
     
      <Route exact path="/topics/:cat" element={<ContentCategory />} />
      <Route exact path="/topics/:cat" element={<ContentCategory />} />
      <Route exact path="/topics/:cat/:subcat" element={<ContentCategory />} />
      <Route exact path="/search/:cat/:searchVal" element={<Searchlist />} />
      <Route exact path="/search/:cat/:searchVal/:subcat" element={<Searchlist />} />
      {/* <Route exact path="/:cat_slug/:post_name" element={<Topic />} />  */}
      <Route exact path="/:cat_slug/:post_name" element={<NewTopicCode />} /> 
      <Route exact path="/preview/:cat_slug/:post_name"  element={<PostPreview />} />
     
      <Route path="*" element={<NotFound />} />
      
    </Routes>

    </>
    
  );
};

export default MainRoutes;